import { render } from "./live-info.vue?vue&type=template&id=7c6ddfba&scoped=true"
import script from "./live-info.vue?vue&type=script&lang=js"
export * from "./live-info.vue?vue&type=script&lang=js"

import "./live-info.vue?vue&type=style&index=0&id=7c6ddfba&scoped=true&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6ddfba"]])

export default __exports__